import { useEffect } from "react";
import { Link } from "react-router-dom";
import { HardDrive, Plus } from "lucide-react";
import useWalletStore from "../../store/wallet.store";

// Compact Zenstorage meter for the wallet/account page.
// Hides itself when the plan has cap=0 (unlimited — B2B contracts).
export default function StorageMeter() {
  const storage = useWalletStore((s) => s.storage);
  const fetchStorage = useWalletStore((s) => s.fetchStorage);

  useEffect(() => {
    fetchStorage();
  }, [fetchStorage]);

  if (!storage || storage.unlimited) return null;

  const usedGB = (storage.used_bytes / 1e9).toFixed(2);
  const capGB = storage.cap_gb;
  const pct = Math.min(100, Math.max(0, storage.percent_used || 0));

  // Tone shifts as the user approaches the cap
  const toneClass =
    pct >= 90 ? "bg-rose-500" :
    pct >= 70 ? "bg-amber-500" :
                "bg-emerald-500";

  return (
    <div className="bg-bg-primary border border-border-default rounded-lg p-4">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2 text-sm text-text-secondary">
          <HardDrive className="w-4 h-4" />
          Zenstorage (video clips)
        </div>
        <div className="text-xs tabular-nums text-text-secondary">
          <span className="text-text-primary font-semibold">{usedGB}</span> / {capGB} GB
        </div>
      </div>
      <div className="w-full bg-bg-secondary rounded-full h-2 overflow-hidden">
        <div className={`${toneClass} h-full transition-all duration-300`} style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-2 flex items-center justify-between gap-3">
        <p className={`text-xs ${pct >= 90 ? "text-rose-300" : pct >= 70 ? "text-amber-300" : "text-text-secondary"}`}>
          {pct >= 90
            ? `You're at ${pct}% of your Zenstorage cap.`
            : pct >= 70
            ? `Approaching cap (${pct}%). Plan ahead to avoid blocked uploads.`
            : `1 GB ≈ 60 ball clips. Top up via plan upgrade.`}
        </p>
        <Link
          to="/subscriptions"
          className="shrink-0 inline-flex items-center gap-1 text-[11px] uppercase tracking-wider px-2 py-1 rounded-md bg-button-primary/15 border border-button-primary/40 text-text-primary hover:bg-button-primary/25"
          title="Upgrade plan for more Zenstorage (₹65/GB-month for overage)"
        >
          <Plus className="w-3 h-3" />
          Buy Zenstorage
        </Link>
      </div>
    </div>
  );
}
